import { render, staticRenderFns } from "./FormInputPermissionResidentGroup.vue?vue&type=template&id=24827c22&scoped=true&lang=pug"
import script from "./FormInputPermissionResidentGroup.vue?vue&type=script&lang=ts"
export * from "./FormInputPermissionResidentGroup.vue?vue&type=script&lang=ts"
import style0 from "./FormInputPermissionResidentGroup.vue?vue&type=style&index=0&id=24827c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24827c22",
  null
  
)

export default component.exports